module.exports = "<div class=hull-banner-container> <h3 class=hull-banner-title>Congratulations! Hull is ready.</h3> <p class=hull-banner-text>Your snippet is correctly installed and configured <br/> <i>This banner is only visible to you.</i></p> <a class=hull-banner-button data-hull-intent=hull.snippet.success href=#>Close Window</a> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/html-loader!./src/utils/ui/platform.html
// module id = 173
// module chunks = 0